export const getChatDateString = (date: Date): string => {
	const now = new Date();
	const isToday = date.toDateString() === now.toDateString();
	return isToday
		? date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })
		: date.toLocaleDateString(undefined, {
				month: 'short',
				day: 'numeric',
				hour: '2-digit',
				minute: '2-digit'
		  });
};
